import dateToParams from '../../utils/dateToParams';
import zonesClient from '../../utils/zonesClient';
import {
  IGetAntiFunnelAmPieProps,
  IGetAntiFunnelZmPieProps,
  IGetFunnelMedianZoneProps,
  IGetFunnelMetropolitanAreaProps,
  IGetZoneIndicators,
} from './model';

export const getFunnelMetropolitanArea = async ({
  metropolitan_area_id,
  date,
  filter,
}: IGetFunnelMetropolitanAreaProps) => {
  const pathMetropolitanArea = process.env.REACT_APP_GET_FUNNEL_METROPOLITAN_AREA;
  const dateParams = dateToParams(date);

  const { data } = await zonesClient.get<IApiResponse>(pathMetropolitanArea!, {
    params: {
      ...dateParams,
      metropolitan_area_id,
      filter,
    },
  });

  return data;
};

export const getFunnelMedianZone = async ({
  median_zone_id,
  date,
  filter,
}: IGetFunnelMedianZoneProps) => {
  const pathMedianZone = process.env.REACT_APP_GET_FUNNEL_MEDIAN_ZONE;
  const dateParams = dateToParams(date);

  const { data } = await zonesClient.get<IApiResponse>(pathMedianZone!, {
    params: {
      ...dateParams,
      median_zone_id,
      filter,
    },
  });

  return data;
};

export const getFunnelStages = async () => {
  const pathFunnelStages = process.env.REACT_APP_GET_FUNNEL_STAGES;
  const { data } = await zonesClient.get<IApiResponse>(pathFunnelStages!, {});
  return data;
};

export const getAntiFunnelPieAM = async (
  paramsApi: IGetAntiFunnelAmPieProps
) => {
  const pathAntiFunnelAM = process.env.REACT_APP_GET_ANTIFUNNEL_PIE_AM;
  const dateParams = dateToParams(paramsApi.date);

  const { data } = await zonesClient.get<IApiResponse>(pathAntiFunnelAM!, {
    params: {
      ...dateParams,
      metropolitan_area_id: paramsApi.metropolitan_area_id,
      filter: paramsApi.filter,
      stage: paramsApi.stageFilter,
    },
  });

  return data;
};

export const getAntiFunnelPieZM = async (
  paramsApi: IGetAntiFunnelZmPieProps
) => {
  const pathAntiFunnelZM = process.env.REACT_APP_GET_ANTIFUNNEL_PIE_ZM;
  const dateParams = dateToParams(paramsApi.date);

  const { data } = await zonesClient.get<IApiResponse>(pathAntiFunnelZM!, {
    params: {
      ...dateParams,
      median_zone_id: paramsApi.median_zone_id,
      filter: paramsApi.filter,
      stage: paramsApi.stageFilter,
    },
  });

  return data;
};

export const getZoneValidations = async (params: IGetZoneIndicators) => {
  const pathIndicatorsGet = process.env.REACT_APP_GET_ZONE_INDICATORS;
  const { data } = await zonesClient.get<IApiResponse>(pathIndicatorsGet!, {
    params,
  });
  return data;
};
